import React, { useState, useEffect } from "react";
import { apiService, history } from "_helpers";
import { useDispatch, useSelector } from "react-redux";
//import { toast } from "react-toastify";

export { InvoicePayments };

function InvoicePayments() {
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showInvDetails, setShowInvDetails] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [invoiceFlag, setinvoiceFlag] = useState("C");
  const [dateRange, setDateRange] = useState("thisMonth");
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("M");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [adjustmentAmount, setAdjustmentAmount] = useState(0);
  const [paymentMode, setPaymentMode] = useState("UPI");
  const [outstandingAsOnAmount, setOutstandingAsOnAmount] = useState(0);
  const [attachment, setAttachment] = useState(null);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const { user: authUser } = useSelector((x) => x.auth);
  const [referenceNo, setReferenceNo] = useState("");
  const [notes, setNotes] = useState("");
  const [invoiceList, setInvoiceList] = useState([]);
  const [invoiceAmountTotal, setInvoiceAmountTotal] = useState(0);
  
  const [paymentList, setPaymentList] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [editingPayment, setEditingPayment] = useState(null);
  const [attachmentPath, setAttachmentPath] = useState("");
  const [bankStatus, setBankStatus] = useState("Pending");
  const dispatch = useDispatch();

  useEffect(() => {
          getInvoiceList();
  }, []);

  const parseDate = (dateVal) => {
    if (!dateVal) return null;

    if (dateVal instanceof Date) {
      return dateVal; // ✅ already parsed
    }

    if (typeof dateVal === "string") {
      const [dd, mm, yyyy] = dateVal.split("/");
      return new Date(`${yyyy}-${mm}-${dd}`);
    }

    throw new Error("Invalid date value");
  };

  const getReceiptCurrentDate = () => {
    const today = new Date();

    return today.toLocaleDateString("en-GB");
  };

  const totalInvAmount = filteredInvoices.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.amount;
  }, 0);
  const totalInvTDSAmount = filteredInvoices.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.tds_amount;
  }, 0);
  const totalInvAdjustAmount = filteredInvoices.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.adjustment_amount;
  }, 0);
  const totalOSAmount = filteredInvoices.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.outstandingAmount;
  }, 0);

  const getOutstandingAsOnDate = () => {
    const today = new Date();
    let _date = new Date();

    // This Month → 1st of current month
    if (dateRange === "thisMonth") {
      _date = new Date(today.getFullYear(), today.getMonth(), 1);
      _date.setDate(_date.getDate() - 1);
      return _date;
    }

    // Previous Month → 1st of previous month
    if (dateRange === "lastMonth") {
      _date = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      _date.setDate(_date.getDate() - 1);
      return _date;
    }

    if (dateRange === "finStart") {
      let _yr = today.getFullYear();
      let _mt = today.getMonth();
      if(_mt<4){_yr=_yr-1;}
      _date = new Date(_yr, 3, 1);
      _date.setDate(_date.getDate() - 1);
      return _date;
    }

    // Date Wise → From Date
    if (dateRange === "custom" && fromDate) {
      _date = new Date(fromDate); 
      _date.setDate(_date.getDate() - 1);
      return _date;
    }

    _date = new Date(today.getFullYear(), today.getMonth(), 1);
    _date.setDate(_date.getDate() - 1);
    return _date;
  };

  const outstandingAsOnDate = getOutstandingAsOnDate();
  const receiptCurrentDate = getReceiptCurrentDate();

  const formattedOutstandingDate = outstandingAsOnDate.toLocaleDateString(
    "en-GB",
    { day: "2-digit", month: "short", year: "numeric" }
  );

  const normalizeDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  const removeAttachment = () => {
    setAttachment(null);
    setAttachmentPath("");
  };
  const getDateRange = (dateRange, fromDate, toDate) => {
    const today = new Date();

    let startDate;
    let endDate;

    if (dateRange === "thisMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = today;
    } else if (dateRange === "lastMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0); // last day prev month
    } else if (dateRange === "finStart") {
      let _yr = today.getFullYear();
      let _mt = today.getMonth();
      if(_mt<4){_yr=_yr-1;}

      startDate = new Date(_yr, 3, 1);
      endDate = today; // last day prev month
    } else if (dateRange === "custom") {
      startDate = fromDate ? new Date(fromDate) : null;
      endDate = toDate ? new Date(toDate) : today;
    }

    return {
      fromDate: startDate ? parseDate(startDate) : null,
      toDate: parseDate(endDate),
    };
  };

  const downloadInvoice = async (event, index, invoice) => {
    event.preventDefault();

    var _InvoiceNumber = invoice.id; 
    var _InvoiceDate = invoice.invoiceDate; 
    var attachPath=`${process.env.REACT_APP_ATTACH_URL}/attachment/invoice/`;
    if(invoice.invoiceFlag==='D'){
      attachPath+=`doctor/`;
    }
    else if(invoice.invoiceFlag==='A'){
      attachPath+=`agent/`;
    }
    else{
      attachPath+=`center/`;
    }

    var _invoice_for_month ='';
    if(invoice.invoice_key > 538){
      _invoice_for_month = invoice.remarks.replace('Service of ', '').replace(' ', '')+'-';
    }

    if(invoice.invoiceFlag==='D'){
      if(_InvoiceDate!==''){
        attachPath+=(_InvoiceDate.split('-')[2]).slice(-2)+`-`+_InvoiceDate.split('-')[1];
      }
    }
    else{
      attachPath+=_InvoiceNumber.split('/')[1];  
    }
    attachPath+=`/`+_invoice_for_month+_InvoiceNumber.replace(/\//g, '_')+'-'+invoice.invoiceToId + '-' + invoice.invoiceToName.replace(/ & /g, ' ').replace(/ /g, '_')+`.pdf`;
    window.open(attachPath, `mytsoftpay-attachinvoice`);
  }

  const viewInvoiceDetails = async (event, param, index, invoice, action) => {
    event.preventDefault();

    setSelectedInvoice(invoice);
    setShowInvDetails(true);

    if(param === 'OPEN'){
      await fetchInvoiceDetails(invoice);
    } 

    if(param === 'SAVE'){
    }

    if(param !== 'OPEN'){
      setShowInvDetails(false);
      setSelectedInvoice(null);
      setInvoiceList([]);
    }

    let modal = document.querySelector("#modalViewInvDetails");
    modal.classList.toggle("closed");    
  }
  const openViewPayment = async (event, param, index, invoice, action) => {
    event.preventDefault();

    setSelectedInvoice(invoice);
    setShowDrawer(true);

    if(param === 'OPEN'){
      await fetchInvoicePayments(invoice);
    } 

    if(param === 'SAVE'){
    }

    if(param !== 'OPEN'){
      setShowDrawer(false);
      setSelectedInvoice(null);
      setPaymentList([]);
    }

    let modal = document.querySelector("#modalViewPayment");
    modal.classList.toggle("closed");    
  }
  const openAttach = async (event, attachPath) => {
    event.preventDefault();
    window.open(attachPath, 'mytsoftpay-attachfile');
  }
  const openPayment = async (event, param, index, invoice, action, payment) => {
    event.preventDefault();

    let hidinv_pay_key = document.getElementById('hidinv_pay_key');
    if(param === 'OPEN'){
      setSelectedInvoice(invoice);
      setShowPayModal(true);

      document.getElementById('spnpayment_hdr').value = invoice.id;
      hidinv_pay_key.value = "0";
      document.getElementById('hidinv_inv_key').value = invoice.invoice_key;
      document.getElementById('hidinv_invoice_to_key').value = invoice.invoice_to_key;
      document.getElementById('hidinv_invoiceFlag').value = invoice.invoiceFlag;
      document.getElementById('txtcenter').value = invoice.invoiceToId + ' - ' + invoice.invoiceToName;
      document.getElementById('txtinvoice_number').value = invoice.id;
      
      document.getElementById('txtinvoice_date').value = invoice.invoiceDate;
      document.getElementById('txtdue_date').value = invoice.dueDate;
      document.getElementById('txtinvoice_amount').value = invoice.amount;

      let txtoutstanding = document.getElementById('txtoutstanding');
      txtoutstanding.value = invoice.outstandingAmount;

      let txtreceipt_number = document.getElementById('txtreceipt_number');
      let txtreceipt_date = document.getElementById('txtreceipt_date');
      let txtpayment_amount = document.getElementById('txtpayment_amount');
      let txtadjustment_amount = document.getElementById('txtadjustment_amount');

      if(param === 'OPEN'){
        txtreceipt_number.value = '';
        txtreceipt_date.valueAsDate = new Date(); // Sets it to today
        txtpayment_amount.value = txtoutstanding.value;
        txtadjustment_amount.value = '0';
        
        document.getElementById('ddlpayment_mode').value = 'UPI';
        document.getElementById('ddlbank_status').value = 'Pending';
        document.getElementById('txtbank_reference').value = '';
        document.getElementById('txtnotes').value = '';
      }

      if(action === 'EDIT'){
        hidinv_pay_key.value = payment.paymentKey;
        txtreceipt_number.value = payment.paymentNumber;
        txtreceipt_date.valueAsDate = new Date(payment.paymentDate);
        txtpayment_amount.value = payment.paymentAmount;
        txtadjustment_amount.value = payment.adjustmentAmount;

        document.getElementById('ddlpayment_mode').value = payment.paymentMode;
        document.getElementById('ddlbank_status').value = payment.bankStatus;
        document.getElementById('txtbank_reference').value = payment.referenceNo;
        document.getElementById('txtnotes').value = payment.notes;

        if (payment.attachmentPath) {
            setAttachmentPath(payment.attachmentPath);
          } else {
            setAttachmentPath("");
          }
        }
    }

    if(param === 'SAVE'){
      try {
        var payment_amount = document.getElementById('txtpayment_amount').value;
        if (payment_amount <= 0) {
          //toast.warning("Payment amount must be greater than zero");
          alert('Payment amount must be greater than zero');
          return false;
        }

        var adjustment_amount = document.getElementById('txtadjustment_amount').value;
        if (adjustment_amount < 0) {
          //toast.warning("Adjustment amount must be greater than zero");
          alert('Adjustment amount must be greater than zero');
          return false;
        }

        if(hidinv_pay_key.value === "0"){
          var _outstanding = document.getElementById('txtoutstanding').value;
          if (Number(payment_amount) + Number(adjustment_amount) > Number(_outstanding)) {
            alert('Outstanding cannot be greater than payment & adjustment amount');
            return false;
          }
        }
        
        setSaving(true);
        
        const formData = prepareSavePaymentFormData();
        const result = await saveInvoicePayment(formData);
        if (!result) {
          alert("Payment could not be saved");
          return false;
        }
        alert("Payment saved successfully.");
        resetPaymentForm();
        setShowPayModal(false);
        const _invoiceList = await getInvoiceList();

        const updatedInvoice = _invoiceList.find(
          (inv) => inv.invoice_key === selectedInvoice.invoice_key
        );
        setSelectedInvoice(updatedInvoice);
        if (showDrawer) {
          await fetchInvoicePayments(updatedInvoice);
        }
      } catch (err) {
        alert(err.message || "Failed to save payment");
        return false;
      } finally {
        setSaving(false);
      }
    }

    if(param === 'CLOSE'){
      setShowPayModal(false);
      resetPaymentForm();
    }
  
    let modal = document.querySelector("#modalPayment");
    modal.classList.toggle("closed");
  };
    
  function randomNumberInRange(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const getInvoiceList = async () => {
    try {
      setLoading(true);
      const request_id = randomNumberInRange(1000000, 9000000);
      const user_key = authUser?.user_key;
      const url = `${process.env.REACT_APP_API_URL}/invoicepayment/GetInvoices`;
      const { fromDate: apiFromDate, toDate: apiToDate } = getDateRange(
        dateRange,
        fromDate,
        toDate
      );

      setToDate(apiToDate.toISOString().split("T")[0]);

      const today = normalizeDate(new Date());

      const from = normalizeDate(apiFromDate);
      const to = normalizeDate(apiToDate);

      if (from > today) {
        alert("From date cannot be greater than today");
        return;
      }
      if (to > today) {
        alert("To date cannot be greater than today");
        return;
      }
      if (from > to) {
        alert("From date cannot be greater than To date");
        return;
      }

      const data = await apiService.get(url, dispatch, {
        customHeaders: {
          invoiceFlag: invoiceFlag,
          userKey: user_key.toString(),
          fromDate: apiFromDate.toISOString(),
          toDate: apiToDate.toISOString(),
          status: statusFilter,
          searchText: searchText,
          request_id: request_id.toString()
        },
      });
      const invoices = (data?.invoices || []).map((inv) => ({
        id: inv.invoiceNumber,
        invoiceToId: inv.invoiceToId,
        invoiceToName: inv.invoiceToName,
        invoiceDate: new Date(inv.invoiceDate).toLocaleDateString("en-GB").replace(/\//g, '-'),
        dueDate: new Date(inv.dueDate).toLocaleDateString("en-GB").replace(/\//g, '-'),
        amount: inv.invoiceAmount,
        tds_amount: inv.tds_amount,
        tds_amount_paid: inv.tds_amount_paid,
        adjustment_amount: inv.adjustment_amount,
        outstandingAmount: inv.outstandingAmount,
        paid: inv.invoiceAmount - inv.outstandingAmount,
        status: inv.status,
        invoice_key: inv.invoiceKey,
        invoice_to_key: inv.invoiceTo,
        invoiceFlag: inv.invoiceFlag,
        remarks: inv.remarks,
        payments: [], // load separately if needed
      }));

      setFilteredInvoices(invoices);
      const amount = data?.outstandingAsOnDate;
      setOutstandingAsOnAmount(amount);
      return invoices || [];
    } catch (error) {
      alert("Failed to fetch invoices. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const prepareSavePaymentFormData = () => {
    const formData = new FormData();

    var value_split = document.getElementById('txtreceipt_date').value.split('-');
    var payment_date = value_split[0] + '-' + value_split[1] + '-' + value_split[2];
    var payment_amount = document.getElementById('txtpayment_amount').value;
    var adjustment_amount = document.getElementById('txtadjustment_amount').value;

    var payment_mode = document.getElementById('ddlpayment_mode').value;
    var bank_status = document.getElementById('ddlbank_status').value;
    var bank_reference = document.getElementById('txtbank_reference').value;
    var notes_value = document.getElementById('txtnotes').value;

    var payment_key = document.getElementById('hidinv_pay_key').value;
    var invoice_key = document.getElementById('hidinv_inv_key').value;
    var invoice_to_key = document.getElementById('hidinv_invoice_to_key').value;
    var invoiceFlag = document.getElementById('hidinv_invoiceFlag').value;

    formData.append("paymentKey", payment_key); //editingPayment ? editingPayment.paymentKey : ""
    formData.append("invoiceFlag", invoiceFlag);
    formData.append("invoiceTo", invoice_to_key);
    formData.append("invoiceKey", invoice_key);
    formData.append("paymentDate", payment_date);
    formData.append("paymentAmount", payment_amount);
    formData.append("adjustmentAmount", adjustment_amount);
    formData.append("paymentMode", payment_mode);
    formData.append("referenceNo", payment_mode === "Cash" ? "" : bank_reference);
    formData.append("bankStatus", payment_mode === "Cash" ? "Deposited" : bank_status);
    formData.append("notes", notes_value);
    formData.append("attachmentPath", attachmentPath);

    if (attachment) {
      formData.append("attachment", attachment);
    }

    formData.append("createdBy", authUser.user_key);

    return formData;
  };

  const resetPaymentForm = () => {
    setPaymentAmount(0);
    setAdjustmentAmount(0);
    setPaymentMode("UPI");
    setReferenceNo("");
    setNotes("");
    setAttachment(null);
    setAttachmentPath("");
  };

  async function saveInvoicePayment(payload) {
    let url = `${process.env.REACT_APP_API_URL}/invoicepayment/SavePayment`;
    /*if (attachment) {
      url = `${process.env.REACT_APP_API_URL_EC2}/invoicepayment/SavePayment`;
    }*/

    const request_id = randomNumberInRange(1000000, 9000000);

    const result = await apiService.post(
      url,
      payload,
      dispatch,
      { 
        contentType: "multipart/form-data",
         headers: {
              "Content-Type": "multipart/form-data",
              "request_id": request_id.toString()
          }
      }
    );

    return result;
  }

 const fetchInvoiceDetails = async (invoice) => {
    setLoadingPayments(true);
    setInvoiceList([]);
    setInvoiceAmountTotal(0);
    const request_id = randomNumberInRange(1000000, 9000000);
    var _invoiceKey = 0;

    try{
      _invoiceKey = invoice.invoice_key;
    }
    catch (err) { ;}

    if(_invoiceKey === 0)
    {
      alert("Unable to process invoice details, invalid invoice key reference.");
      return;
    }

    try{
      const data = await apiService.get(
        `${process.env.REACT_APP_API_URL}/invoicepayment/GetInvoiceDetails`,
        dispatch,
        {
          customHeaders: {
            invoiceFlag: invoiceFlag,
            invoiceKey: _invoiceKey,
            request_id: request_id.toString()
          },
        }
      );

      if (data) {
        setInvoiceList(data);
        
        const _invoiceAmountTotal = data.reduce((sum, item) => sum + (item.amount || 0), 0);
        setInvoiceAmountTotal(_invoiceAmountTotal);
      }
    }catch (err) {;}

    setLoadingPayments(false);
  };

  const fetchInvoicePayments = async (invoice) => {
    setLoadingPayments(true);
    setPaymentList([]);
    const request_id = randomNumberInRange(1000000, 9000000);
    var _invoiceKey = 0;

    try{
      _invoiceKey = invoice.invoice_key;
    }
    catch (err) { ;}

    var _InvoiceTo = 0;
    try{
      _InvoiceTo = invoice.invoice_to_key;
    }
    catch (err) {     
      try{
        _InvoiceTo = invoice.invoiceTo;
      }
      catch (err1) {
      }
    }
    
    if(_invoiceKey === 0 || _InvoiceTo === 0)
    {
      alert("Unable to process payment details, invalid invoice key reference.");
      return;
    }

    try{
      const data = await apiService.get(
        `${process.env.REACT_APP_API_URL}/invoicepayment/GetPayments`,
        dispatch,
        {
          customHeaders: {
            invoiceFlag: invoiceFlag,
            InvoiceTo: _InvoiceTo,
            invoiceKey: _invoiceKey,
            request_id: request_id.toString()
          },
        }
      );

      if (data) {
        setPaymentList(data);
      }
    }catch (err) {;}

    setLoadingPayments(false);
  };
  
  const handleAttachmentChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // size validation
    if (file.size > 5 * 1024 * 1024) {
      alert("File size must be under 5MB");
      return;
    }

    const allowedTypes = ["image/", "application/pdf"];
    if (!allowedTypes.some((t) => file.type.startsWith(t))) {
      alert("Only PDF or image files allowed");
      return;
    }

    setAttachment(file);
  };

  const handlePreviewAttachment = () => {
    if (attachment) {
      // Before upload (local file)
      const blobUrl = URL.createObjectURL(attachment);
      window.open(blobUrl, "_blank");
      return;
    }

    if (attachmentPath) {
      // After upload (server file)
      window.open(
        `${process.env.REACT_APP_API_URL}/${attachmentPath}`,
        "_blank"
      );
    }
  };
  const getAttachmentName = () => {
    if (attachment) return attachment.name;

    if (attachmentPath) {
      return attachmentPath.split("/").pop(); // extract filename
    }

    return "";
  };

  return (
    <div className="tele-body">
      <main>
        <div className="container-fluid px-4">
          <div className="row">
              <div className="col-12 col-lg-12 col-md-12 col-sm-12 mt-2">
                  <div className="accordion" id="accordionPanelsStayOpenExample">
                      <div className="accordion-item">
                          <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                              <button className="accordion-button" type="button" aria-expanded="true" >
                                  <i className="bi bi-file-earmark-medical iconcolr-w">&nbsp; </i> Manage invoice payments
                              </button>
                          </h2>
                          <div id="panelsStayOpen-collapseOne" className="accordion-collapse show"
                              aria-labelledby="panelsStayOpen-headingOne">
                              <div className="accordion-body">
                                  <div className="row">
                                    <div className="col-5 col-lg-2 col-md-2 col-sm-12 mt-1">
                                      <select
                                        className="form-select form-select-sm"
                                        id="ddlinvoiceFlag"
                                        name="ddlinvoiceFlag"
                                        value={invoiceFlag}
                                        onChange={(e) => setinvoiceFlag(e.target.value)}
                                      >
                                        <option value="C" selected>Center Invoice</option>
                                        <option value="D">Doctor Invoice</option>
                                        <option value="A">Agent Invoice</option>
                                      </select>
                                    </div>
                                    <div className="col-7 col-md-2 col-lg-2 mt-1">
                                      <input
                                        type="text"
                                        placeholder="Search Invoice / Center"
                                        className="form-control"
                                        onChange={(e) => setSearchText(e.target.value)}
                                      />
                                    </div>
                                    <div className="col-5 col-md-2 col-lg-2 mt-1">
                                      <select
                                        className="form-select form-select-sm"
                                        id="ddlSelection"
                                        name="ddlSelection"
                                        onChange={(event) =>
                                          setDateRange(event.target.value)
                                        }
                                      >
                                        <option value="thisMonth">This Month</option>
                                        <option value="lastMonth">Previous Month</option>
                                        <option value="finStart">From Financial Start</option>
                                        <option value="custom">Date Wise</option>
                                      </select>
                                    </div>
                                    {dateRange === "custom" && (
                                      <div className="col-4 col-lg-4 col-md-4 col-sm-12 mt-1">
                                        <div className="row">
                                          <div className="col-6">
                                            <input
                                              type="date"
                                              className="form-control form-control-sm"
                                              value={fromDate}
                                              onChange={(e) => setFromDate(e.target.value)}
                                            />
                                          </div>
                                          <div className="col-6">
                                            <input
                                              type="date"
                                              className="form-control form-control-sm"
                                              value={toDate}
                                              onChange={(e) => setToDate(e.target.value)}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="col-7 col-lg-2 col-md-2 col-sm-12 mt-1">
                                      <select
                                        className="form-select form-select-sm"
                                        id="ddlStatusfilter"
                                        name="ddlStatusfilter"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                      >
                                        <option value="A">All Status</option>
                                        <option value="P">Paid</option>
                                        <option value="S">Partial</option>
                                        <option value="U" selected>Unpaid</option>
                                        <option value="M" selected>Partial/Unpaid</option>
                                      </select>
                                    </div>
                                    <div className="col-12 col-lg-2 col-md-2 col-sm-12 mt-1">
                                      <button
                                        type="button"
                                        className="btn btn-dark btn-sm btn-block text-light bi bi-play-fill"
                                        id="btnApply"
                                        onClick={(event) => getInvoiceList(event)}
                                        disabled={loading}
                                      >
                                        {" "}
                                        {loading ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm me-2"
                                              role="status"
                                            />
                                            Searching...
                                          </>
                                        ) : (
                                          <>Search</>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-2">
              <div className="tab-content" id="tblInvoiceDtls">
                <div className="tab-pane fade show active mt-2" id="all-tab-pane" role="tabpanel"
                                    aria-labelledby="all-tab" tabindex="0">
                  <div className="card">
                    <div className="card-header bg-gradient-1 text-light">
                      <div className="row align-items-center text-center">
                        {/* Center – wider */}
                        <div className="col-4 col-md-2 text-start">
                          <span className="tele-table-heading">Invoice To</span>
                        </div>

                        {/* Invoice # */}
                        <div className="col-2 col-md-2 d-none d-md-block">
                          <span className="tele-table-heading">Invoice #</span>
                        </div>

                        {/* Invoice Date – reduced */}
                        <div className="col-2 col-md-1 d-none d-md-block">
                          <span className="tele-table-heading">
                            Invoice Date
                          </span>
                        </div>

                        {/* Due Date – reduced */}
                        <div className="col-2 col-md-1 d-none d-md-block">
                          <span className="tele-table-heading">Due Date</span>
                        </div>

                        {/* Amount */}
                        <div className="col-2 col-md-1 d-md-block text-end">
                          <span className="tele-table-heading">Amount</span>
                        </div>

                        <div className="col-2 col-md-1 d-md-block text-end d-none d-md-block">
                          <span className="tele-table-heading">TDS</span>
                        </div>
                        <div className="col-2 col-md-1 d-md-block text-end d-none d-md-block">
                          <span className="tele-table-heading">Adjustment</span>
                        </div>

                        {/* Outstanding */}
                        <div className="col-2 col-md-1 d-md-block text-end">
                          <span className="tele-table-heading">
                            Outstanding
                          </span>
                        </div>

                        {/* Status */}
                        <div className="col-2 col-md-1 d-md-block">
                          <span className="tele-table-heading">Status</span>
                        </div>

                        {/* Action */}
                        <div className="col-1 col-md-1 d-md-block">
                          <span className="tele-table-heading">Action</span>
                        </div>
                      </div>
                    </div>

                    <div className="card-footer tele-table-padding text-light">
                      <div className="row align-items-center text-center">
                        {/* Center – wider */}
                        <div className="col-4 col-md-2 text-start">
                          <p className="tele-table-dash-text">
                            Outstanding as on {outstandingAsOnDate.toLocaleDateString("en-GB").replace(/\//g, '-')}
                          </p>
                        </div>

                        {/* Invoice # */}
                        <div className="col-2 col-md-2 d-none d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>

                        {/* Invoice Date – reduced */}
                        <div className="col-2 col-md-1 d-none d-md-block text-right">
                          <p className="tele-table-dash-text">
                            
                          </p>
                        </div>

                        {/* Due Date – reduced */}
                        <div className="col-2 col-md-1 d-none d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>

                        {/* Amount */}
                        <div className="col-2 col-md-1 d-md-block text-end">
                          <span className="tele-table-heading"></span>
                        </div>

                        <div className="col-2 col-md-1 d-md-block text-end d-none d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>
                        <div className="col-2 col-md-1 d-md-block text-end d-none d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>

                        {/* Outstanding */}
                        <div className="col-2 col-md-1 text-end d-md-block">
                          <p className="tele-table-dash-text" style={{paddingRight:"6.5px"}}>{outstandingAsOnAmount}</p>
                        </div>

                        {/* Status */}
                        <div className="col-2 col-md-1 d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>

                        {/* Action */}
                        <div className="col-1 col-md-1 d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>
                      </div>
                    </div>

                    <div className="card-body tele-table-padding invoice-studylist-area">
                      {filteredInvoices.map((inv, i) => (
                        <div
                          key={inv.id}
                          className="row studylist align-items-center"
                        >
                          {/* Center */}
                          <div className="col-4 col-md-2">
                            <p className="tele-table-dash-text">{inv.invoiceToId} - {inv.invoiceToName}</p>
                          </div>

                          {/* Invoice # */}
                          <div className="col-2 col-md-2 d-none d-md-block text-center">
                            <p className="tele-table-dash-text">{inv.id} 
                              <br/> <span style={{fontSize:"10px"}}>{inv.remarks}</span>
                            </p>
                          </div>

                          {/* Invoice Date (reduced width) */}
                          <div className="col-2 col-md-1 d-none d-md-block text-right">
                            <p className="tele-table-dash-text">{inv.invoiceDate}</p>
                          </div>

                          {/* Due Date (reduced width) */}
                          <div className="col-2 col-md-1 d-none d-md-block text-right">
                            <p className="tele-table-dash-text">{inv.dueDate}</p>
                          </div>

                          {/* Amount */}
                          <div className="col-2 col-md-1 text-end d-md-block">
                            <p className="tele-table-dash-text">{inv.amount}</p>
                          </div>

                          <div className="col-2 col-md-1 text-end d-md-block d-none d-md-block">
                            <p className="tele-table-dash-text">{inv.tds_amount}</p>
                          </div>
                          <div className="col-2 col-md-1 text-end d-md-block d-none d-md-block">
                            <p className="tele-table-dash-text">{inv.adjustment_amount}</p>
                          </div>

                          {/* Outstanding */}
                          <div className="col-2 col-md-1 text-end d-md-block">
                            <p className="tele-table-dash-text">{inv.outstandingAmount}</p>
                          </div>

                          {/* Status */}
                          <div className="col-2 col-md-1 d-md-block text-center">
                            <p className="tele-table-dash-text">
                              {inv.status}
                            </p>
                          </div>

                          {/* Action */}
                          <div className="col-2 col-md-d-pending d-md-block text-center">
                            <button
                              className="btn btn-sm btn-light me-2"
                              onClick={event => openPayment(event, 'OPEN', i, inv, 'ADD')}
                            >
                              Pay
                            </button>
                            
                            <button
                              className="btn btn-sm btn-link p-0"
                              onClick={event => openViewPayment(event, 'OPEN', i, inv, 'VIEW')}
                              title="View Payment"
                            >
                              {(inv.status === 'Unpaid' ? 
                                <i className="bi bi-eye text-dark"></i>
                              :
                                <i className="bi bi-eye-fill text-dark"></i>
                              )}
                              
                            </button>
                              &nbsp;

                            <button
                              className="btn btn-sm btn-link p-0"
                              onClick={event => viewInvoiceDetails(event, 'OPEN', i, inv, 'VIEW')}
                              title="View Invoice Details"
                            >
                              <i className="bi bi-list-task text-dark"></i>
                              
                            </button>
                              &nbsp;

                            {((inv.invoice_key > 314 & inv.invoiceFlag==='C') || (inv.invoice_key > 538 & inv.invoiceFlag==='D') ? 
                                <button
                                  className="btn btn-sm btn-link p-0"
                                  onClick={event => downloadInvoice(event, i, inv)}
                                  title="Download Invoice"
                                >
                                  <i className="bi bi-paperclip text-dark"></i>
                                </button>
                              : <span></span>
                            )}

                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="card-footer bg-gradient-1 text-light">
                      <div className="row align-items-center text-center">
                        {/* Center – wider */}
                        <div className="col-4 col-md-2 text-start">
                          <span className="tele-table-heading">Total</span>
                        </div>

                        {/* Invoice # */}
                        <div className="col-2 col-md-2 d-none d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>

                        {/* Invoice Date – reduced */}
                        <div className="col-2 col-md-1 d-none d-md-block">
                          <span className="tele-table-heading">
                          </span>
                        </div>

                        {/* Due Date – reduced */}
                        <div className="col-2 col-md-1 d-none d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>

                        {/* Amount */}
                        <div className="col-2 col-md-1 d-md-block text-end">
                          <span className="tele-table-heading">{totalInvAmount}</span>
                        </div>

                        <div className="col-2 col-md-1 d-md-block text-end d-none d-md-block">
                          <span className="tele-table-heading">{totalInvTDSAmount}</span>
                        </div>
                        <div className="col-2 col-md-1 d-md-block text-end d-none d-md-block">
                          <span className="tele-table-heading">{totalInvAdjustAmount}</span>
                        </div>

                        {/* Outstanding */}
                        <div className="col-2 col-md-1 text-end d-md-block">
                          <span className="tele-table-heading">{outstandingAsOnAmount + totalOSAmount}</span>
                        </div>

                        {/* Status */}
                        <div className="col-2 col-md-1 d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>

                        {/* Action */}
                        <div className="col-1 col-md-1 d-md-block">
                          <span className="tele-table-heading"></span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      {/* Pay Modal */}
      <div id="modalPayment" className="modal closed" style={{zIndex:"21055"}}>
        {/*<!-- Modal content -->*/}
          <div className="payment-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" id="close-button" onClick={event => openPayment(event, 'CLOSE', null)}>&times;</span>
                  <h6 className="mb-0"><i className="bi bi-person-circle"></i> Payment Against Invoice # : <span id="spnpayment_hdr"></span></h6>
                  <input type="hidden" id="hidinv_pay_key" />
                  <input type="hidden" id="hidinv_inv_key" />
                  <input type="hidden" id="hidinv_invoice_to_key" />
                  <input type="hidden" id="hidinv_invoiceFlag" />
              </div>
              <div className="modal-body">
                  <div className="row">
                      <div className="col-lg-12 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice To:</small></span></div> <input type="text" placeholder=""
                                  required="required" className="form-control" 
                                  id="txtcenter" readOnly />
                          </div>
                      </div>

                      <div className="col-lg-6 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice#:</small></span></div> <input type="text" placeholder=""
                                  required="required" className="form-control"
                                  id="txtinvoice_number" readOnly />
                          </div>
                      </div>
                      <div className="col-lg-3 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice Date:</small></span></div> 
                                      <input type="text" placeholder=""
                                        required="required" className="form-control"
                                        id="txtinvoice_date" readOnly />
                          </div>
                      </div>
                      <div className="col-lg-3 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Due Date:</small></span></div> 
                                      <input type="text" placeholder=""
                                        required="required" className="form-control"
                                        id="txtdue_date" readOnly />
                          </div>
                      </div>

                      <div className="col-lg-6 col-6 pe-1">
                        <div className="input-group input-group-sm mt-2">
                            <div className="input-group-prepend"><span className="input-group-text input-sm">
                              <small>Invoice Amount</small></span></div>
                              <input type="text" required="required" className="form-control"
                                id="txtinvoice_amount" readOnly />
                        </div>
                      </div>
                      <div className="col-lg-6 col-6 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice Outstanding</small></span></div> <input type="text"
                                  required="required" className="form-control"
                                  id="txtoutstanding" readOnly />
                          </div>
                      </div>
                      
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Receipt#:</small></span></div> <input type="text" placeholder=""
                                    required="required" className="form-control"
                                    id="txtreceipt_number" readOnly />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                  <small>Receipt Date:</small></span></div> 
                                  <input type="date" required="required" placeholder="" 
                                    className="form-control form-control-sm tele-table-searcharea" 
                                    id="txtreceipt_date" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Payment Amount:</small></span></div> <input type="text" placeholder="Amount"
                                    required="required" className="form-control"
                                    id="txtpayment_amount" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Adjustment Amount:</small></span></div> <input type="text" placeholder="Amount"
                                    required="required" className="form-control"
                                    id="txtadjustment_amount" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Payment Mode:</small></span></div> 
                                        <select className="form-select form-select-sm float-right m-1" id="ddlpayment_mode">
                                          <option value="UPI">UPI</option>
                                          <option value="Bank Transfer">Bank Transfer</option>
                                          <option value="Cash">Cash</option>
                                          <option value="Cheque">Cheque</option>
                                        </select>
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Bank Status:</small></span></div> 
                                        <select className="form-select form-select-sm float-right m-1" id="ddlbank_status">
                                          <option value="Pending">Pending</option>
                                          <option value="Deposited">Deposited</option>
                                          <option value="Bounced">Bounced</option>
                                        </select>

                            </div>
                        </div>

                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Bank Reference:</small></span></div> 
                                        <input type="text" placeholder="Transaction / Cheque#"
                                          required="required" className="form-control"
                                          id="txtbank_reference" />
                            </div>
                        </div>
                  </div>
                  <div className="row justify-content-center pb-1">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label className="font-size14">Notes:</label>
                                <textarea className="form-control font-size14" 
                                  rows="2" id="txtnotes"
                                  placeholder="Optional remarks">
                                </textarea>
                            </div>
                        </div>
                  </div>
                  
                  <div className="row justify-content-center pb-1">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            {!(attachment || attachmentPath) ? (
                              <label className="attach-btn">
                                📎 Attach File
                                <input
                                  type="file"
                                  hidden
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  onChange={handleAttachmentChange}
                                />
                              </label>
                            ) : (
                              <div className="attached-file">
                                {/* Click to preview */}
                                <span
                                  className="file-name"
                                  style={{ cursor: "pointer", color: "#0d6efd" }}
                                  onClick={handlePreviewAttachment}
                                  title="Click to preview"
                                >
                                  {getAttachmentName()}
                                </span>

                                {/* Remove */}
                                <button
                                  type="button"
                                  className="remove-file"
                                  onClick={removeAttachment}
                                >
                                  ✕
                                </button>
                              </div>
                            )}

                        </div>
                  </div>

              </div>


              <div className="modal-footer pt-2">
                <div className="row justify-content-center pb-0">
                    <div className="col-lg-4 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnPaymentSave" onClick={event => openPayment(event, 'SAVE')}> 
                            {saving ? " Saving... " : " SAVE "}
                            </button></div>
                    <div className="col-lg-4 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnPaymentClose" onClick={event => openPayment(event, 'CLOSE')}> CANCEL </button></div>
                </div>
              </div>
          </div>
      </div>
      
      <div id="modalViewPayment" className="modal closed" style={{zIndex:"21050"}}>
        {/*<!-- Modal content -->*/}
        {showDrawer && (
          <div className="payment-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" id="close-button" onClick={event => openViewPayment(event, 'CLOSE', null)}>&times;</span>
                  <h6 className="mb-0"><i className="bi bi-person-circle"></i> Payment Against Invoice # : {selectedInvoice.id}<span></span></h6>
                  
              </div>
              <div className="modal-body">
                  <div className="row">
                      <div className="col-lg-12 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice To:</small></span></div> <input type="text" placeholder=""
                                  required="required" className="form-control" value={selectedInvoice.invoiceToId + ' - ' + selectedInvoice.invoiceToName}
                                  id="txtcenter_v" readOnly />
                          </div>
                      </div>

                      <div className="col-lg-6 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice#:</small></span></div> <input type="text" placeholder=""
                                  required="required" className="form-control" value={selectedInvoice.id}
                                  id="txtinvoice_number_v" readOnly />
                          </div>
                      </div>
                      <div className="col-lg-3 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice Date:</small></span></div> 
                                      <input type="text" placeholder=""
                                        required="required" className="form-control" value={selectedInvoice.invoiceDate}
                                        id="txtinvoice_date_v" readOnly />
                          </div>
                      </div>
                      <div className="col-lg-3 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Due Date:</small></span></div> 
                                      <input type="text" placeholder=""
                                        required="required" className="form-control" value={selectedInvoice.dueDate}
                                        id="txtdue_date_v" readOnly />
                          </div>
                      </div>

                      <div className="col-lg-6 col-6 pe-1">
                        <div className="input-group input-group-sm mt-2">
                            <div className="input-group-prepend"><span className="input-group-text input-sm">
                              <small>Invoice Amount</small></span></div>
                              <input type="text" required="required" className="form-control"
                                id="txtinvoice_amount_v" value={selectedInvoice.amount} readOnly />
                        </div>
                      </div>
                      <div className="col-lg-6 col-6 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-2">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice Outstanding</small></span></div> <input type="text"
                                  required="required" className="form-control"
                                  id="txtoutstanding_v" value={selectedInvoice.outstandingAmount} readOnly />
                          </div>
                      </div>
                      
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Payment Amount:</small></span></div> <input type="text" placeholder="Amount"
                                    required="required" className="form-control" value={selectedInvoice.paid}
                                    id="txtpayment_amount_v" readOnly />
                            </div>
                        </div>
                  </div>
                  <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label className="font-size14">Payment History:</label>
            {loadingPayments ? (
                <div className="text-muted">Loading payments...</div>
              ) : paymentList.length === 0 ? (
                <div className="text-muted">No payments found</div>
              ) : (
                <table className="inner-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Type</th>
                      <th>Number</th>
                      <th>Mode</th>
                      <th>Ref</th>
                      <th>Payment</th>
                      <th>Adjustment</th>
                      <th>Status</th>
                      <th>Attach</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentList.map((p, i) => (
                      <tr key={i}>
                        <td>
                          {new Date(p.paymentDate).toLocaleDateString("en-GB").replace(/\//g, '-')}
                        </td>
                        <td>{p.paymentType}</td>
                        <td>{p.paymentNumber}</td>
                        <td>{p.paymentMode}</td>
                        <td>{p.referenceNo}</td>
                        <td>{p.paymentAmount}</td>
                        <td>{p.adjustmentAmount}</td>
                        <td>{p.bankStatus}</td>
                        <td>
                          {(p.attachmentPath === "" ? 
                                <span>No File</span>
                              : 
                              <button
                                className="btn-link"
                                onClick={event => openAttach(event, p.attachmentPath)}
                              >
                                Open File
                              </button>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn-small"
                            onClick={event => openPayment(event, 'OPEN', i, selectedInvoice, 'EDIT', p)}
                          >
                            View/Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

                                
                            </div>
                        </div>
                  </div>

              </div>


              <div className="modal-footer pt-2">
                <div className="row justify-content-center pb-0">
                    <div className="col-lg-4 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnPaymentClose" onClick={event => openViewPayment(event, 'CLOSE')}> CLOSE </button></div>
                </div>
              </div>
          </div>
        )}
      </div>

      <div id="modalViewInvDetails" className="modal closed" style={{zIndex:"210451"}}>
        {/*<!-- Modal content -->*/}
        {showInvDetails && (
          <div className="invoicedtls-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" id="close-button" onClick={event => viewInvoiceDetails(event, 'CLOSE', null)}>&times;</span>
                  <h6 className="mb-0"><i className="bi bi-person-circle"></i> Details of the Invoice # : {selectedInvoice.id}<span></span></h6>
                  
              </div>
              <div className="modal-body">
                  <div className="row">
                      <div className="col-lg-12 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-0">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice To:</small></span></div> <input type="text" placeholder=""
                                  required="required" className="form-control" value={selectedInvoice.invoiceToId + ' - ' + selectedInvoice.invoiceToName}
                                  id="txtcenter_i" readOnly />
                          </div>
                      </div>

                      <div className="col-lg-6 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-0">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice#:</small></span></div> <input type="text" placeholder=""
                                  required="required" className="form-control" value={selectedInvoice.id}
                                  id="txtinvoice_number_i" readOnly />
                          </div>
                      </div>
                      <div className="col-lg-3 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-0">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice Date:</small></span></div> 
                                      <input type="text" placeholder=""
                                        required="required" className="form-control" value={selectedInvoice.invoiceDate}
                                        id="txtinvoice_date_i" readOnly />
                          </div>
                      </div>
                      <div className="col-lg-3 col-12 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-0">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Due Date:</small></span></div> 
                                      <input type="text" placeholder=""
                                        required="required" className="form-control" value={selectedInvoice.dueDate}
                                        id="txtdue_date_i" readOnly />
                          </div>
                      </div>

                      <div className="col-lg-6 col-6 pe-1">
                        <div className="input-group input-group-sm mt-0">
                            <div className="input-group-prepend"><span className="input-group-text input-sm">
                              <small>Invoice Amount</small></span></div>
                              <input type="text" required="required" className="form-control"
                                id="txtinvoice_amount_i" value={selectedInvoice.amount} readOnly />
                        </div>
                      </div>
                      <div className="col-lg-6 col-6 ps-1 pe-1">
                          <div className="input-group input-group-sm mt-0">
                              <div className="input-group-prepend"><span className="input-group-text input-sm">
                                      <small>Invoice Outstanding</small></span></div> <input type="text"
                                  required="required" className="form-control"
                                  id="txtoutstanding_i" value={selectedInvoice.outstandingAmount} readOnly />
                          </div>
                      </div>
                      
                  </div>
                  <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-0">
                                
            {loadingPayments ? (
                <div className="text-muted">Loading invoice details...</div>
              ) : invoiceList.length === 0 ? (
                <div className="text-muted">No invoice details found</div>
              ) : (
                <div className="card-body tele-table-padding invoice-dtls-studylist-area">
                <table className="inner-table">
                  <thead>
                    <tr style={{ borderTop: '1.5px solid #333', borderBottom: '1.5px solid #333', fontWeight: 'bold'}}>
                      <th>Modality</th>
                      <th>Particulars</th>
                      <th className="text-end">Qty</th>
                      <th className="text-center">Rate</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceList.map((currentRow, index, array) => {
                    // 1. Trace the older ID by looking back one index
                    const previousRow = index > 0 ? array[index - 1] : null;

                    // 2. Check if this is a new group (or the very first item)
                    let isNewGroup = !previousRow || previousRow.account_id !== currentRow.account_id;
                    if(invoiceFlag !== 'A') {
                      isNewGroup = false;
                    }

                    return (
                      <React.Fragment key={index}>
                      {/* 3. Inject a full-width header row only when the ID changes */}
                      {isNewGroup && (
                        <tr style={{ fontWeight: 'bold'}}>
                          <td>
                            {currentRow.account_id}
                          </td>
                          <td colSpan={4}>
                            {currentRow.account_name}
                          </td>
                        </tr>
                      )}

                      <tr key={index} style={{ borderBottom: '1px solid #eee'}}>
                        <td>{currentRow.modality}</td>
                        <td>{currentRow.particulars}</td>
                        <td className="text-end">{currentRow.quantity}</td>
                        <td className="text-center">{currentRow.rate}</td>
                        <td className="text-end">{currentRow.amount}</td>
                      </tr>
                      </React.Fragment>
                    );
                  })}

                  </tbody>

                   <tfoot>
                    <tr style={{ borderTop: '1px solid #333', fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>
                      <td colSpan={4} className="text-end">
                        Total Amount:
                      </td>
                      <td className="text-end">
                        {invoiceAmountTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                  </tfoot>
                </table>
                </div>
              )}

                                
                            </div>
                        </div>
                  </div>

              </div>


              <div className="modal-footer pt-2">
                <div className="row justify-content-center pb-0">
                    <div className="col-lg-4 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btInvDetailsClose" onClick={event => viewInvoiceDetails(event, 'CLOSE')}> CLOSE </button></div>
                </div>
              </div>
          </div>
        )}
      </div>

    </div>
  );
}

